import React from 'react';
const stackData = [
  {
    category: "Мобильное приложение",
    desc: "Разработка мобильных приложений для Android Ios.",
    techs: ["Android", "Ios", "KMP", "Kotlin", "Swift"]
  },
  {
    category: "Frontend Разработка",
    desc: "Создание интерактивных и отзывчивых пользовательских интерфейсов.",
    techs: ["React", "JavaScript", "TypeScript", "HTML5", "CSS3", "Node.js (Next.js)"]
  },
  {
    category: "Backend & Серверная часть",
    desc: "Проектирование надежной архитектуры и API.",
    techs: ["Node.js", "Express", "REST API", "MySQL", "Linux / Ubuntu"]
  },
  {
    category: "Desktop (Windows) & Системное ПО",
    desc: "Высокопроизводительные нативные приложения.",
    techs: ["C++", "Windows API", "Базы данных", "Многопоточность", "Native Development"]
  },
  {
    category: "Ai ассистент",
    desc: "Голосовой ассистент отвечающий на звонки 24/7.",
    techs: ["Yandex SpeechKit", "Wisper", "Asterix", "TTS"]
  },
  {
    category: "Сервер",
    desc: "Собственный безопасный сервер, надежное хранение данных.",
    techs: ["Ubuntu", "WAF", "SIEM", "Firewall"]
  }
];
function Stack() {
  return (
    <div className="fade-in">
      <div className="page-header">
        <h1 className="page-title">Технологический стек</h1>
        <p className="page-subtitle">Инструменты, которые мы используем для решения задач любой сложности: от веба до системного программирования.</p>
      </div>
      <div className="services-grid">
        {stackData.map((item, index) => (
          <div key={index} className="card">
            <h3 className="tech-category">{item.category}</h3>
            <p className="service-desc">{item.desc}</p>
            <div className="tech-list">
              {item.techs.map((tech, i) => (
                <span key={i} className="tech-badge">{tech}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
export default Stack;